import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";
import line from '../../theme/assets/svg/lp_afi_s3_line.svg';

const AfiS3 = () => {
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentWrapTitle}`}><span>{t('Простой и понятный')}</span> {t('процесс подачи заявки и запуска')}</div>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemNumberWrap}`}>
                            <div className={`${Styles.contentBoxItemNumber}`}>1</div>
                            <div className={`${Styles.contentBoxItemAbsLine}`}>
                                <img src={line} alt="line"/>
                            </div>
                        </div>
                        <div className={`${Styles.contentBoxItemTextWrap}`}>
                            <div className={`${Styles.contentBoxItemTextWrapTitle}`}>{t('Заявка')}</div>
                            <div className={`${Styles.contentBoxItemTextWrapNote}`}>{t('Проекты подают заявку с подробной информацией о продукте, команде, токеномике и дорожной карте.')}</div>
                        </div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemNumberWrap}`}>
                            <div className={`${Styles.contentBoxItemNumber}`}>2</div>
                            <div className={`${Styles.contentBoxItemAbsLine}`}>
                                <img src={line} alt="line"/>
                            </div>
                        </div>
                        <div className={`${Styles.contentBoxItemTextWrap}`}>
                            <div className={`${Styles.contentBoxItemTextWrapTitle}`}>{t('Проверка due diligence')}</div>
                            <div className={`${Styles.contentBoxItemTextWrapNote}`}>{t('Наша команда проводит углублённую оценку ключевых параметров проекта, включая бэкграунд команды, видение, токеномическую модель и готовность к реализации.')}</div>
                        </div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemNumberWrap}`}>
                            <div className={`${Styles.contentBoxItemNumber}`}>3</div>
                            <div className={`${Styles.contentBoxItemAbsLine}`}>
                                <img src={line} alt="line"/>
                            </div>
                        </div>
                        <div className={`${Styles.contentBoxItemTextWrap}`}>
                            <div className={`${Styles.contentBoxItemTextWrapTitle}`}>{t('Внутренний обзор')}</div>
                            <div className={`${Styles.contentBoxItemTextWrapNote}`}>{t('Отобранные проекты проходят внутреннюю оценку, по итогам которой принимается финальное решение.')}</div>
                        </div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemNumberWrap}`}>
                            <div className={`${Styles.contentBoxItemNumber}`}>4</div>
                            <div className={`${Styles.contentBoxItemAbsLine}`}>
                                <img src={line} alt="line"/>
                            </div>
                        </div>
                        <div className={`${Styles.contentBoxItemTextWrap}`}>
                            <div className={`${Styles.contentBoxItemTextWrapTitle}`}>{t('Подготовка к запуску')}</div>
                            <div className={`${Styles.contentBoxItemTextWrapNote}`}>{t('Одобренные проекты получают структурированную поддержку при подготовке к запуску — включая механику, сроки, коммуникации и техническую готовность.')}</div>
                        </div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemNumberWrap}`}>
                            <div className={`${Styles.contentBoxItemNumber}`}>5</div>
                            <div className={`${Styles.contentBoxItemAbsLine}`}>
                                <img src={line} alt="line"/>
                            </div>
                        </div>
                        <div className={`${Styles.contentBoxItemTextWrap}`}>
                            <div className={`${Styles.contentBoxItemTextWrapTitle}`}>{t('Запуск и поддержка')}</div>
                            <div className={`${Styles.contentBoxItemTextWrapNote}`}>{t('Проекты запускаются на нашей платформе по заранее определённым правилам и условиям.')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AfiS3;




